export default __webpack_public_path__ + "media/images/landing-39-550x420-490a6750b0d985dc64b15dc594d7d2fc.jpg";